import React from 'react';
import { Button, Card } from 'react-bootstrap';
import upgradeCrossSellCover from 'assets/images/loyaltyRewards/upgrade-cross-sell-cover.png';

interface UpgradeCrossSellProps {
  onClose: () => void;
  onExplore: () => void;
}

const UpgradeCrossSell: React.FC<UpgradeCrossSellProps> = ({
  onClose,
  onExplore,
}) => (
  <div className="mt-5 mb-4">
    <Card>
      <Card.Img variant="top" src={upgradeCrossSellCover} alt="Cover Upgrade" />
      <Card.Body className="px-4 py-3 mb-2">
        <h3 className="fs-3 fw-bold text-left">Want more from your cover?</h3>
        <p className="mb-4 lh-base text-left" style={{ fontSize: '1.15rem' }}>
          Choose add-ons if you’d like to enhance your cover with extra
          protection and benefits.
        </p>
        <Button
          className="w-100 border-0 fw-bold py-3"
          onClick={onExplore}
          style={{
            fontSize: '1.15rem',
            background: '#F95108',
            borderRadius: '6px',
          }}
        >
          Explore upgrades
        </Button>
      </Card.Body>
    </Card>
    <div className="text-center mt-4">
      <Button
        className="text-secondary p-0 fw-bold text-decoration-underline"
        variant="link"
        onClick={onClose}
        style={{ fontSize: '1.15rem' }}
      >
        Close
      </Button>
    </div>
  </div>
);

export default UpgradeCrossSell;
